/** Excel trata como início de fórmula. */
const PREFIXO_FORMULA = /^[+=@-]/

/** `HH:mm` sozinho: o Excel converte em hora e exibe como número. */
const HORARIO = /^\d{2,3}:\d{2}$/

/**
 * Escapa uma célula do CSV. O tab dentro das aspas é o que força o Excel a
 * tratar o conteúdo como texto — só aspas não bastam, o parser as remove
 * antes de inferir o tipo.
 */
export function formatarValorCsv(value: unknown): string {
    if (value === null || value === undefined) return ''

    const texto = String(value)

    if (PREFIXO_FORMULA.test(texto) || HORARIO.test(texto))
        return `"\t${texto}"`

    return `"${texto}"`
}

/**
 * Seleciona as colunas que entram no CSV. `hide: false` é a coluna que o
 * usuário exibiu no painel — ela entra; só `hide: true` fica fora.
 */
export function colunasExportaveis<T>(
    colunas: (T & { hide?: boolean; disableExport?: boolean })[],
): T[] {
    return colunas.filter(
        coluna => coluna.disableExport !== true && coluna.hide !== true,
    )
}
